import type { ContactRole } from '@gozoki/api-types'
import { gozokiApiWithAuth } from '../gozokiApi'

export interface ContactResponse {
  id: string
  name: string
  email: string
  phone: string
  contactRole: ContactRole | null
}

export interface CreateContactPayload {
  name: string
  email?: string
  phone?: string
  contactRole?: ContactRole | null
}

export interface UpdateContactPayload extends CreateContactPayload {
  id: string
}

export const fetchContacts = async (): Promise<ContactResponse[]> => {
  const response = await gozokiApiWithAuth.get<ContactResponse[]>('/contacts')
  return response.data
}

export const createContact = async (payload: CreateContactPayload): Promise<ContactResponse> => {
  const response = await gozokiApiWithAuth.post<ContactResponse>('/contacts', payload)
  return response.data
}

export const updateContact = async (payload: UpdateContactPayload): Promise<ContactResponse> => {
  const response = await gozokiApiWithAuth.patch<ContactResponse>(`/contacts/${payload.id}`, {
    name: payload.name,
    email: payload.email,
    phone: payload.phone,
    contactRole: payload.contactRole,
  })
  return response.data
}
